module.exports = __webpack_public_path__ + "static/browser@2x-bf74f1543cb66ce5dbae7e32d91077fe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/why-marvel/browser@2x.jpg
// module id = 2717
// module chunks = 168707334958949